import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { ResendRecipeNotificationInput } from './ResendRecipeNotificationInput';
import { ResendRecipeNotificationOutput } from './ResendRecipeNotificationOutput';

export class ResendRecipeNotificationService extends HttpServiceBase {

  handle = (input: ResendRecipeNotificationInput): Promise<Result<ResendRecipeNotificationOutput> | null> => {
    const promise = this.http.put<Result<ResendRecipeNotificationOutput>, ResendRecipeNotificationInput>(
      `${this.baseUrlSislogApi}/v2/recipe/notification/${input.recipeNotificationId}`, input);
    return promise;
  }
}